(() => {
  if (!customElements.get('wnc-kit-stories')) {
    customElements.define('wnc-kit-stories', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.addEventListener('click', event => {
          const trigger = event.target.closest('[data-story-open]');
          if (trigger) {
            const dialog = this.querySelector(`#${CSS.escape(trigger.dataset.storyOpen)}`);
            if (!dialog) return;
            this.lastTrigger = trigger;
            const player = dialog.querySelector('[data-story-player]');
            if (!player.children.length) player.append(dialog.querySelector('template').content.cloneNode(true));
            dialog.showModal();
            player.querySelector('video')?.play().catch(() => {});
          }
          const close = event.target.closest('[data-story-close]');
          if (close) close.closest('dialog').close();
          if (event.target instanceof HTMLDialogElement && event.target.open) {
            const rect = event.target.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
          }
        }, { signal: this.abort.signal });
        this.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('close', () => {
          dialog.querySelector('video')?.pause();
          this.lastTrigger?.focus();
        }, { signal: this.abort.signal }));
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.querySelectorAll('video').forEach(video => video.pause());
        this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      }
    });
  }
  if (!window.wncKitContentBound) {
    window.wncKitContentBound = true;
    document.addEventListener('click', event => {
      if (!event.target.closest('[data-kit-return]')) return;
      const product = document.querySelector('wnc-product-kit');
      if (!product) return;
      product.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      product.querySelector('[data-tier]')?.focus({ preventScroll: true });
    });
  }
})();
